import { normalizeMailtoHref, normalizeTelHref } from './supportContactDefaults';

const shapeBlockFallback = (block) => ({
  phone: block.phone,
  email: block.email,
  horaires: block.horaires,
  telHref: normalizeTelHref(block.phone),
  mailtoHref: normalizeMailtoHref(block.email)
});

export const DEFAULT_ORGANIZATION = {
  entreprise: {
    nom: 'Universal Cold',
    phone: '+596 696 16 74 59',
    email: 'contact.universalcold@gmail.com',
    horaires: 'Lundi - Samedi, 6h00 - 19h00 (heure de Martinique)'
  },
  secretariat: {
    phone: '+596 696 82 74 14',
    email: 'universalcold.secretariat@gmail.com',
    horaires: 'Lundi - Vendredi, 8h00 - 13h00 / 14h00 - 16h00 (heure de Martinique)'
  },
  support: {
    phone: '+596 696 79 67 65',
    email: 'fbsdev@gmail.com',
    horaires: '24/7'
  },
  dpo: {
    email: 'privacy@universalcoldplannit.com',
    courrier: '[Adresse postale à compléter]'
  }
};

export const fallbackOrganizationContact = () => ({
  entreprise: {
    nom: DEFAULT_ORGANIZATION.entreprise.nom,
    ...shapeBlockFallback(DEFAULT_ORGANIZATION.entreprise)
  },
  secretariat: shapeBlockFallback(DEFAULT_ORGANIZATION.secretariat),
  support: shapeBlockFallback(DEFAULT_ORGANIZATION.support),
  dpo: {
    email: DEFAULT_ORGANIZATION.dpo.email,
    courrier: DEFAULT_ORGANIZATION.dpo.courrier,
    mailtoHref: normalizeMailtoHref(DEFAULT_ORGANIZATION.dpo.email)
  }
});
